import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TralalereService } from "../services/tralalere.service";

/**
 * Bloque l'activation des pages tant que la session n'est pas validée : sans ce garde,
 * une page peut lancer ses appels API (getClasses() lit user.groups) avant que
 * l'accesstoken soit vérifié.
 * - pas de token -> page de login (dev : saisie manuelle / debugToken)
 * - token refusé -> page unauthorized
 */
export const authGuard: CanActivateFn = async () => {
  const trala = inject(TralalereService);
  const router = inject(Router);

  const status = await trala.ensureAuth();
  if (status === "ok") {
    return true;
  }
  return router.createUrlTree([status === "no-token" ? "/login" : "/unauthorized"]);
};
